module.exports = __webpack_public_path__ + "static/media/cybercrime-large.c941d7ec.png";